var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15,
    fill: "#CD6FC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.617 9.30331C20.71 9.39635 20.782 9.49883 20.8329 9.61074C20.8838 9.72266 20.9081 9.84959 20.9057 9.99153L20.7169 19.3913C20.7112 19.6761 20.6086 19.9183 20.4091 20.1178C20.2096 20.3173 19.9672 20.4202 19.6818 20.4264C19.397 20.4321 19.1615 20.3419 18.9754 20.1559C18.7894 19.9698 18.6992 19.7343 18.7049 19.4495L18.845 12.4709L10.7093 20.6066C10.5035 20.8124 10.267 20.9149 9.99989 20.9141C9.73274 20.9133 9.50054 20.8142 9.3033 20.617C9.10559 20.4193 9.00923 20.184 9.01424 19.911C9.01925 19.638 9.12513 19.3986 9.3319 19.1928L17.4494 11.0753L10.4708 11.2154C10.186 11.2211 9.95053 11.1309 9.76445 10.9449C9.57837 10.7588 9.48819 10.5233 9.49391 10.2385C9.49963 9.95363 9.60249 9.71121 9.80249 9.51121C10.0025 9.31121 10.2447 9.20859 10.529 9.20335L19.9288 9.0146C20.0712 9.01174 20.1984 9.03577 20.3103 9.08667C20.4222 9.13757 20.5244 9.20978 20.617 9.30331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbContact);
export default __webpack_public_path__ + "static/media/nb_contact.62832dfbfad43a26fb81890fc60b7dde.svg";
export { ForwardRef as ReactComponent };